import { Link } from "react-router-dom";
 
import coreImg2 from '../../assets/img/home3/Vision & Strategy .png';

const CoreFeaturesOne = () => {
    return (
        <section className="content-block-wrapper section-padding bg-circle fix pt-0">
            <div className="container">
                 
                <div className="row align-items-center section-padding pt-0 pb-0">
                    <div className="col-xl-6 col-lg-6 col-12 mt-5 mt-lg-0 order-2 order-lg-1">
                        <div className="section-title-3">
                            {/* <h6>Core Features</h6> */}
                            <h2> Vision & Strategy </h2>
                            <p>Over the past decade, Shree Gita Group has expanded and diversified its business through strategic investments in various manufacturing sectors. This growth strategy has enabled us to achieve consistent, year-on-year success while strengthening our market presence. </p>
                        </div>
                        <div className="checked-features-list style-2">
                        <h6 className="p-2 pt-4">Our operations encompass: </h6> 
                            <ul>
                                <li>Sourcing & Production – Managing a diverse range of raw materials and agricultural products. </li>
                                <li>Processing & Refining – Transforming raw materials into refined and packaged goods. </li>
                                <li>Storage & Logistics – Ensuring efficient handling, transportation, and distribution for both domestic and international markets. </li>
                                <li>Research & Merchandising – Continuously innovating to stay ahead in every market we serve.  </li>
                                <li>Customization & Distribution – Catering to a wide customer base, from multinational corporations to local manufacturers.  </li>
                            </ul>
                        </div>
                        <Link to='/about' className="theme-btn style-3 mt-30">Discover Us  </Link>
                    </div>
                    <div className="col-xl-6 col-lg-6 ps-xl-5 col-12 order-1 order-lg-2">
                        <div className="content-block-img">
                            <img src={coreImg2} alt="" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CoreFeaturesOne;